import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from "../../../../common/variables/translate-service";
import { GlobalVariableService } from "../../../../common/variables/global-variable";
import { GlobalFunctionService } from "../../../../common/services/global-function.service";
import { Global } from "../../../../common/utilities/global";
import { ImagePathService } from "../../../../common/variables/image-path.service";
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'sen-app-details-statics',
  templateUrl: './details-statics.component.html',
  styleUrls: ['./details-statics.component.scss']
})
export class DetailsStaticsComponent implements OnInit {
  @ViewChild(MatTable) staticsTable: MatTable<any>;
  displayedColumns: string[] = ['name', 'F', 'G', 'H'];
  dataSource = new MatTableDataSource();
  selectedProject$: Observable<any[]>;

  constructor(public dialogRef: MatDialogRef<DetailsStaticsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public translate: TranslateService,
    private store: Store<any>,
    public globalF: GlobalFunctionService,
    public global: GlobalVariableService,
    public imagePath: ImagePathService
  ) {
    this.selectedProject$ = this.store.select(state => { return state.appData.selectedProject });
  }


  ngOnInit(): void {
    this.dataSource = new MatTableDataSource(this.data.aData);
  }

  closeDialogue() {
    this.dialogRef.close()
  }

  get bgColorH() {
    return Global.colDach;
  }
  get bgColorF() {
    return Global.colDachF;
  }
  get bgColorG() {
    return Global.colDachG;
  }

}